var Backbone = require('backbone');
var _ = require('underscore');

var Index = require('front/pages/Index/Index');
var About = require('front/pages/About/About');
var Artist = require('front/pages/Artist/Artist');

var NotFound = require('front/pages/NotFound/NotFound');
var Section = require('front/pages/Section/Section');
var SubSectionDummy = require('front/pages/Section/SubSectionDummy');
var PaintingsPopup = require('front/pages/Index/PaintingsPopup');

var ANIMATION_DURATION = 500;


module.exports = Backbone.Router.extend({
    routes: {
        '(en/)': 'index',
        '(en/)about(/)': 'about',
        '(en/)artist(/)': 'artist',
        '(en/)painting/:paintingId(/)': 'paintingsPopup',
        '(en/)painting/:paintingId/:userKey(/)': 'paintingsPopup'
    },

    notFound: function () {
        this.activate(NotFound);
    },

    index: function () {
        this.activate(Index, {view: SubSectionDummy, viewData: {}});
    },

    about: function () {
        this.activate(About, {view: SubSectionDummy, viewData: {}});
    },

    artist: function () {
        this.activate(Artist, {view: SubSectionDummy, viewData: {}});
    },

    paintingsPopup: function (paintingId, userKey) {
        //на телефоне нет попапа галереи
        if (app.settings.isPhone && !userKey) {
            Backbone.history.navigate('/', {trigger: 'true'});

            return;
        }

        this.activate(Index, {view: PaintingsPopup, viewData: {paintingId: paintingId, userKey: userKey}});
    },

    activate: function (view, params) {
        params = params || {};

        // вьюха отрендерена на сервере
        if (!app.state.view) {
            params.server = true;
            params.inAnimated = false;
            app.state.view = new view(params);
            app.state.view.activate();

            return;
        }

        app.state.prevView = app.state.view;
        //this.activateStandardLogic(view, params);
        //return;
        if (this.isSectionLogic(app.state.prevView, view, params)) {
            this.activateSectionLogic(params);
        } else {
            this.activateStandardLogic(view, params);
        }
    },

    // активация перехода с полной перезагрузкой и лоадером
    activateStandardLogic: function (view, params) {
        var newParams = _.defaults({server: false, inAnimated: true}, params);
        var newView = new view(newParams);
        var duration = params.fastNavigate ? 0 : ANIMATION_DURATION;
        var self = this;

        return Promise.all([app.state.view.playOut({duration: duration, zoom: params.zoomNavigate, view: newView}), newView.loadData()])
            .then(function () {
                app.els.$content.css({minHeight: app.els.$content.height()});

                return app.state.view.deactivate({destroy: true});
            })
            .then(function () {
                app.state.isServer = false;
                app.state.view = newView;
                app.state.view.activate(newParams)
                    .then(function () {
                        app.els.$content.css({minHeight: ''});
                        $(window).scrollTop(0);

                        return app.state.view.playIn({duration: duration, zoom: params.zoomNavigate, view: newView});
                    });
            });
    },

    // активация перехода со шторкой
    activateSectionLogic: function (subSectionParams) {
        var view = subSectionParams.view;
        var params = _.omit(subSectionParams, 'view');
        params.server = false;
        params.inAnimated = true;
        app.state.view.update(view, params);
        app.state.isServer = false;
    },


    isSectionLogic: function (prevView, view, params) {
        return app.state.prevView instanceof Section && app.state.prevView.constructor === view;
        //return app.state.prevView instanceof Section && view === Section;
    },


    start: function () {
        var is404 = app.els.$body.hasClass('Page404');
        var pushStateSupported = history && _.isFunction(history.pushState);
        Backbone.history.start({pushState: pushStateSupported, silent: is404});
        if (is404) {
            this.notFound();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/Router.js
// module id = 16
// module chunks = 0